import {Component, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ImagePathConstants} from 'src/app/core/constants/image-path-constants';
import {SetImageDimensionsDirective} from 'src/app/core/directives/set-image-dimensions.directive';
import {JoinWaitlistComponent} from 'src/app/modal/join-waitlist/join-waitlist.component';
import {WaitlistSubscribedComponent} from 'src/app/modal/waitlist-subscribed/waitlist-subscribed.component';
import {SeoService} from '../../core/services/common-service/seo.service';
import {RoutesConstants} from '@coreconstant';
import {MetaDataConstants} from '../../core/constants/meta-data-constants';

@Component({
    selector: 'app-planning-hub',
    imports: [SetImageDimensionsDirective],
    templateUrl: './planning-hub.component.html',
    styleUrl: './planning-hub.component.scss',
    providers: [NgbActiveModal],
    encapsulation: ViewEncapsulation.None
})

export class PlanningHubComponent {
    imagePathConstants = ImagePathConstants
    routesConstants = RoutesConstants;

    constructor(
        private _modalService: NgbModal,
        private _seoService: SeoService,
    ) {
        this.setMetaTags()
    }

    /**
     * Sets the meta tags for the current page by creating a meta tag object and passes it to the SEO service for application.
     * @return {void} Does not return a value.
     */
    setMetaTags() {
        let metaTagObject = {
            title: MetaDataConstants.PLANNING_HUB.TITLE,
            description: MetaDataConstants.PLANNING_HUB.DESCRIPTION,
            ogImageUrl: MetaDataConstants.PLANNING_HUB.OGIMAGEURL,
            ogWebUrl: this.routesConstants.PLANNING,
        }
        this._seoService.setMetaTags(metaTagObject)
    }

    /**
     * Opens a modal dialog for joining the waitlist.
     */
    joinWaitlistModal() {
        const JoinWaitlistModal = this._modalService.open(JoinWaitlistComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            modalDialogClass: 'join-waitlist-modal'
        });

        JoinWaitlistModal.result.then(
            (result) => {
                if (result == 'success')
                    this.openSuccessModal()
            },
            (reason) => {
            }
        );
    }

    /**
     * Opens a success modal using the modal service with specific configurations.
     */
    openSuccessModal() {
        this._modalService.open(WaitlistSubscribedComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            modalDialogClass: 'waitlist-modal'
        });
    }
}
